@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(950_195_948)
internal val Res.string.rule_infinito_card_2: StringResource by lazy {
      StringResource("string:rule_infinito_card_2", "rule_infinito_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248267, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245083, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246446, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236091, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230407, 60),
      ))
    }

@delegate:ResourceContentHash(953_835_117)
internal val Res.string.rule_infinito_card_3: StringResource by lazy {
      StringResource("string:rule_infinito_card_3", "rule_infinito_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248332, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245144, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246511, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236152, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230468, 60),
      ))
    }

@delegate:ResourceContentHash(15_277_558)
internal val Res.string.rule_infinito_card_4: StringResource by lazy {
      StringResource("string:rule_infinito_card_4", "rule_infinito_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248401, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245209, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246576, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236217, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230529, 112),
      ))
    }

@delegate:ResourceContentHash(-1_497_610_500)
internal val Res.string.rule_infinito_card_5: StringResource by lazy {
      StringResource("string:rule_infinito_card_5", "rule_infinito_card_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248510, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245326, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246689, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236326, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230642, 60),
      ))
    }

@delegate:ResourceContentHash(1_109_459_196)
internal val Res.string.rule_infinito_card_6: StringResource by lazy {
      StringResource("string:rule_infinito_card_6", "rule_infinito_card_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248575, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245387, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246754, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236387, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230703, 112),
      ))
    }

@delegate:ResourceContentHash(-778_440_923)
internal val Res.string.rule_infinito_card_7: StringResource by lazy {
      StringResource("string:rule_infinito_card_7", "rule_infinito_card_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248708, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245504, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246879, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236508, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230816, 80),
      ))
    }

@delegate:ResourceContentHash(947_369_445)
internal val Res.string.rule_infinito_card_8: StringResource by lazy {
      StringResource("string:rule_infinito_card_8", "rule_infinito_card_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248793, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245589, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 246960, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236585, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230897, 60),
      ))
    }

@delegate:ResourceContentHash(2_117_619_101)
internal val Res.string.rule_infinito_card_9: StringResource by lazy {
      StringResource("string:rule_infinito_card_9", "rule_infinito_card_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248858, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245650, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247025, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236646, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230958, 104),
      ))
    }

@delegate:ResourceContentHash(657_719_086)
internal val Res.string.rule_infinito_ex_2gem: StringResource by lazy {
      StringResource("string:rule_infinito_ex_2gem", "rule_infinito_ex_2gem", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 248967, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245759, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247138, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236763, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231063, 69),
      ))
    }

@delegate:ResourceContentHash(285_236_728)
internal val Res.string.rule_infinito_ex_3inf: StringResource by lazy {
      StringResource("string:rule_infinito_ex_3inf", "rule_infinito_ex_3inf", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249037, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245825, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247208, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236829, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231133, 69),
      ))
    }

@delegate:ResourceContentHash(-1_791_466_238)
internal val Res.string.rule_infinito_title: StringResource by lazy {
      StringResource("string:rule_infinito_title", "rule_infinito_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249107, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245891, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247278, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236891, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231203, 47),
      ))
    }

@delegate:ResourceContentHash(1_895_770_466)
internal val Res.string.rule_participi_card_1: StringResource by lazy {
      StringResource("string:rule_participi_card_1", "rule_participi_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249155, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245939, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247322, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 236935, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231251, 113),
      ))
    }

@delegate:ResourceContentHash(699_155_347)
internal val Res.string.rule_participi_card_2: StringResource by lazy {
      StringResource("string:rule_participi_card_2", "rule_participi_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249285, 173),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246069, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247472, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 237077, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231365, 153),
      ))
    }

@delegate:ResourceContentHash(1_409_070_028)
internal val Res.string.rule_participi_card_3: StringResource by lazy {
      StringResource("string:rule_participi_card_3", "rule_participi_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249459, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246247, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247658, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 237247, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231519, 133),
      ))
    }

@delegate:ResourceContentHash(-110_685_387)
internal val Res.string.rule_participi_card_4: StringResource by lazy {
      StringResource("string:rule_participi_card_4", "rule_participi_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249617, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246397, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247808, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 237401, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231653, 133),
      ))
    }

@delegate:ResourceContentHash(370_817_772)
internal val Res.string.rule_participi_ex_htp: StringResource by lazy {
      StringResource("string:rule_participi_ex_htp", "rule_participi_ex_htp", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249767, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246555, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 247950, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 237551, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231787, 61),
      ))
    }

@delegate:ResourceContentHash(-1_821_128_739)
internal val Res.string.rule_participi_ex_nfrhtp: StringResource by lazy {
      StringResource("string:rule_participi_ex_nfrhtp", "rule_participi_ex_nfrhtp", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249829, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246621, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 248020, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 237617, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231849, 120),
      ))
    }

@delegate:ResourceContentHash(1_668_140_635)
internal val Res.string.rule_participi_title: StringResource by lazy {
      StringResource("string:rule_participi_title", "rule_participi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 249962, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246742, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 248157, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 237738, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 231970, 44),
      ))
    }

@delegate:ResourceContentHash(1_675_105_574)
internal val Res.string.rule_possessivo_suffisso_card_1: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_card_1", "rule_possessivo_suffisso_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 250011, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246791, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 248202, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 237783, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232015, 115),
      ))
    }

@delegate:ResourceContentHash(186_992_268)
internal val Res.string.rule_possessivo_suffisso_card_2: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_card_2", "rule_possessivo_suffisso_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 250143, 295),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246923, 275),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 248338, 267),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 237911, 259),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232131, 251),
      ))
    }

@delegate:ResourceContentHash(-2_094_628_011)
internal val Res.string.rule_possessivo_suffisso_card_3: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_card_3", "rule_possessivo_suffisso_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 250439, 287),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 247199, 311),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 248606, 307),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238171, 275),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232383, 263),
      ))
    }

@delegate:ResourceContentHash(-2_096_355_055)
internal val Res.string.rule_possessivo_suffisso_ex_haty: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_ex_haty", "rule_possessivo_suffisso_ex_haty", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 250727, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 247511, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 248914, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238447, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232647, 84),
      ))
    }

@delegate:ResourceContentHash(116_057_274)
internal val Res.string.rule_possessivo_suffisso_ex_ib_f: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_ex_ib_f", "rule_possessivo_suffisso_ex_ib_f", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 250816, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 247596, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249003, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238528, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232732, 64),
      ))
    }

@delegate:ResourceContentHash(2_115_218_666)
internal val Res.string.rule_possessivo_suffisso_ex_pr_f: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_ex_pr_f", "rule_possessivo_suffisso_ex_pr_f", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 250885, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 247661, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249076, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238597, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232797, 64),
      ))
    }

@delegate:ResourceContentHash(-1_354_020_529)
internal val Res.string.rule_possessivo_suffisso_ex_pr_i: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_ex_pr_i", "rule_possessivo_suffisso_ex_pr_i", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 250950, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 247734, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249157, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238678, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232862, 64),
      ))
    }

@delegate:ResourceContentHash(-531_769_709)
internal val Res.string.rule_possessivo_suffisso_ex_pr_k: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_ex_pr_k", "rule_possessivo_suffisso_ex_pr_k", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 251015, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 247795, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249226, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238747, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232927, 88),
      ))
    }

@delegate:ResourceContentHash(-944_499_977)
internal val Res.string.rule_possessivo_suffisso_ex_pr_n: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_ex_pr_n", "rule_possessivo_suffisso_ex_pr_n", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 251112, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 247884, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249319, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238840, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233016, 64),
      ))
    }

@delegate:ResourceContentHash(-279_711_075)
internal val Res.string.rule_possessivo_suffisso_ex_pr_ss: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_ex_pr_ss", "rule_possessivo_suffisso_ex_pr_ss", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 251177, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 247953, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249392, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238913, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233081, 81),
      ))
    }

@delegate:ResourceContentHash(101_836_332)
internal val Res.string.rule_possessivo_suffisso_title: StringResource by lazy {
      StringResource("string:rule_possessivo_suffisso_title", "rule_possessivo_suffisso_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 251263, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 248035, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249478, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 238995, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233163, 66),
      ))
    }

@delegate:ResourceContentHash(-371_818_644)
internal val Res.string.rule_preposizioni_card_1: StringResource by lazy {
      StringResource("string:rule_preposizioni_card_1", "rule_preposizioni_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 251330, 368),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 248098, 348),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249545, 356),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 239066, 356),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233230, 316),
      ))
    }

@delegate:ResourceContentHash(-1_804_215_862)
internal val Res.string.rule_preposizioni_card_2: StringResource by lazy {
      StringResource("string:rule_preposizioni_card_2", "rule_preposizioni_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 251699, 348),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 248447, 336),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 249902, 356),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 239423, 332),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233547, 304),
      ))
    }

@delegate:ResourceContentHash(-433_022_108)
internal val Res.string.rule_preposizioni_card_3: StringResource by lazy {
      StringResource("string:rule_preposizioni_card_3", "rule_preposizioni_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 252048, 356),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 248784, 340),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 250259, 404),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 239756, 344),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 233852, 324),
      ))
    }

@delegate:ResourceContentHash(1_685_343_440)
internal val Res.string.rule_preposizioni_card_4: StringResource by lazy {
      StringResource("string:rule_preposizioni_card_4", "rule_preposizioni_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 252405, 384),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 249125, 384),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 250664, 432),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 240101, 388),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234177, 356),
      ))
    }

@delegate:ResourceContentHash(-874_781_274)
internal val Res.string.rule_preposizioni_card_5: StringResource by lazy {
      StringResource("string:rule_preposizioni_card_5", "rule_preposizioni_card_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 252790, 292),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 249510, 292),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 251097, 316),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 240490, 288),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234534, 272),
      ))
    }

@delegate:ResourceContentHash(977_140_576)
internal val Res.string.rule_preposizioni_ex_dr_rk_hrw: StringResource by lazy {
      StringResource("string:rule_preposizioni_ex_dr_rk_hrw", "rule_preposizioni_ex_dr_rk_hrw", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253083, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 249803, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 251414, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 240779, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234807, 126),
      ))
    }

@delegate:ResourceContentHash(652_656_964)
internal val Res.string.rule_preposizioni_ex_frase_misteriosa: StringResource by lazy {
      StringResource("string:rule_preposizioni_ex_frase_misteriosa", "rule_preposizioni_ex_frase_misteriosa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253214, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 249938, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 251557, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 240906, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234934, 153),
      ))
    }

@delegate:ResourceContentHash(-1_646_869_403)
internal val Res.string.rule_preposizioni_ex_hr_distributivo: StringResource by lazy {
      StringResource("string:rule_preposizioni_ex_hr_distributivo", "rule_preposizioni_ex_hr_distributivo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253348, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250088, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 251723, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241044, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235088, 96),
      ))
    }

@delegate:ResourceContentHash(-539_973_408)
internal val Res.string.rule_preposizioni_ex_hr_sopra: StringResource by lazy {
      StringResource("string:rule_preposizioni_ex_hr_sopra", "rule_preposizioni_ex_hr_sopra", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253449, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250185, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 251832, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241141, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235185, 93),
      ))
    }

@delegate:ResourceContentHash(-801_348_422)
internal val Res.string.rule_preposizioni_ex_m_avverbiale: StringResource by lazy {
      StringResource("string:rule_preposizioni_ex_m_avverbiale", "rule_preposizioni_ex_m_avverbiale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253547, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250287, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 251934, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241235, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235279, 73),
      ))
    }

@delegate:ResourceContentHash(432_803_673)
internal val Res.string.rule_preposizioni_title: StringResource by lazy {
      StringResource("string:rule_preposizioni_title", "rule_preposizioni_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253613, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250365, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252012, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241309, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235353, 47),
      ))
    }

@delegate:ResourceContentHash(1_622_017_514)
internal val Res.string.rule_pronomi_suffissi_card_1: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_card_1", "rule_pronomi_suffissi_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253665, 156),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250417, 176),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252068, 168),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241361, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235401, 172),
      ))
    }

@delegate:ResourceContentHash(-734_664_937)
internal val Res.string.rule_pronomi_suffissi_card_2: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_card_2", "rule_pronomi_suffissi_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253822, 148),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250594, 176),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252237, 152),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241526, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235574, 132),
      ))
    }

@delegate:ResourceContentHash(193_736_356)
internal val Res.string.rule_pronomi_suffissi_ex_egli: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_egli", "rule_pronomi_suffissi_ex_egli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 253971, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250771, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252390, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241679, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235707, 49),
      ))
    }

@delegate:ResourceContentHash(1_579_373_561)
internal val Res.string.rule_pronomi_suffissi_ex_ella: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_ella", "rule_pronomi_suffissi_ex_ella", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254021, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250821, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252444, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241729, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235757, 49),
      ))
    }

@delegate:ResourceContentHash(19_324_570)
internal val Res.string.rule_pronomi_suffissi_ex_essi: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_essi", "rule_pronomi_suffissi_ex_essi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254071, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250871, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252502, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241779, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235807, 53),
      ))
    }

@delegate:ResourceContentHash(-15_603_280)
internal val Res.string.rule_pronomi_suffissi_ex_esso: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_esso", "rule_pronomi_suffissi_ex_esso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254133, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250925, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252560, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241833, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235861, 49),
      ))
    }

@delegate:ResourceContentHash(334_417_330)
internal val Res.string.rule_pronomi_suffissi_ex_io: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_io", "rule_pronomi_suffissi_ex_io", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254183, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 250975, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252618, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241887, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235911, 43),
      ))
    }

@delegate:ResourceContentHash(69_992_406)
internal val Res.string.rule_pronomi_suffissi_ex_noi: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_noi", "rule_pronomi_suffissi_ex_noi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254231, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251023, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252670, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241935, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235955, 48),
      ))
    }

@delegate:ResourceContentHash(-1_771_142_945)
internal val Res.string.rule_pronomi_suffissi_ex_tu_f: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_tu_f", "rule_pronomi_suffissi_ex_tu_f", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254280, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251080, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252727, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 241984, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236004, 57),
      ))
    }

@delegate:ResourceContentHash(507_474_410)
internal val Res.string.rule_pronomi_suffissi_ex_tu_m: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_tu_m", "rule_pronomi_suffissi_ex_tu_m", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254338, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251138, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252789, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242042, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236062, 57),
      ))
    }

@delegate:ResourceContentHash(1_905_894_312)
internal val Res.string.rule_pronomi_suffissi_ex_voi: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_ex_voi", "rule_pronomi_suffissi_ex_voi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254392, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251196, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252851, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242096, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236120, 60),
      ))
    }

@delegate:ResourceContentHash(-1_179_216_004)
internal val Res.string.rule_pronomi_suffissi_title: StringResource by lazy {
      StringResource("string:rule_pronomi_suffissi_title", "rule_pronomi_suffissi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254445, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251257, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252912, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242149, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236181, 55),
      ))
    }

@delegate:ResourceContentHash(-1_288_923_879)
internal val Res.string.rule_simboli_card_1: StringResource by lazy {
      StringResource("string:rule_simboli_card_1", "rule_simboli_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254501, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251317, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 252972, 155),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242209, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236237, 123),
      ))
    }

@delegate:ResourceContentHash(1_476_707_449)
internal val Res.string.rule_simboli_card_2: StringResource by lazy {
      StringResource("string:rule_simboli_card_2", "rule_simboli_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254649, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251453, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 253128, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242345, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236361, 127),
      ))
    }

@delegate:ResourceContentHash(-913_096_177)
internal val Res.string.rule_simboli_card_3: StringResource by lazy {
      StringResource("string:rule_simboli_card_3", "rule_simboli_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254789, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251585, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 253272, 163),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242477, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236489, 131),
      ))
    }

@delegate:ResourceContentHash(312_379_269)
internal val Res.string.rule_simboli_card_4: StringResource by lazy {
      StringResource("string:rule_simboli_card_4", "rule_simboli_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 254921, 251),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251733, 219),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 253436, 243),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242641, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236621, 215),
      ))
    }

@delegate:ResourceContentHash(-783_905_688)
internal val Res.string.rule_simboli_ex_determinativo: StringResource by lazy {
      StringResource("string:rule_simboli_ex_determinativo", "rule_simboli_ex_determinativo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255173, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 251953, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 253680, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242853, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236837, 69),
      ))
    }

@delegate:ResourceContentHash(-850_631_760)
internal val Res.string.rule_simboli_ex_fonogramma: StringResource by lazy {
      StringResource("string:rule_simboli_ex_fonogramma", "rule_simboli_ex_fonogramma", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255243, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 252027, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 253754, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242927, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236907, 38),
      ))
    }

@delegate:ResourceContentHash(1_783_654_213)
internal val Res.string.rule_simboli_ex_ideogramma: StringResource by lazy {
      StringResource("string:rule_simboli_ex_ideogramma", "rule_simboli_ex_ideogramma", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255282, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 252066, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 253793, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 242966, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 236946, 54),
      ))
    }

@delegate:ResourceContentHash(-1_826_166_589)
internal val Res.string.rule_simboli_title: StringResource by lazy {
      StringResource("string:rule_simboli_title", "rule_simboli_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255349, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 252125, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 253856, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 243025, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237001, 38),
      ))
    }

@delegate:ResourceContentHash(-616_545_092)
internal val Res.string.rule_tipi_verbi_card_1: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_1", "rule_tipi_verbi_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255388, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 252164, 162),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 253895, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 243064, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237040, 146),
      ))
    }

@delegate:ResourceContentHash(-1_019_217_621)
internal val Res.string.rule_tipi_verbi_card_2: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_2", "rule_tipi_verbi_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255543, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 252327, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 254038, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 243211, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237187, 62),
      ))
    }

@delegate:ResourceContentHash(-1_906_957_724)
internal val Res.string.rule_tipi_verbi_card_3: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_3", "rule_tipi_verbi_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255606, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 252390, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 254101, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 243274, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237250, 134),
      ))
    }

@delegate:ResourceContentHash(-1_825_828_376)
internal val Res.string.rule_tipi_verbi_card_4: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_4", "rule_tipi_verbi_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255753, 206),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 252533, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 254236, 214),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 243413, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237385, 190),
      ))
    }

@delegate:ResourceContentHash(-1_501_330_563)
internal val Res.string.rule_tipi_verbi_card_5: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_5", "rule_tipi_verbi_card_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 255960, 282),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 252724, 282),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 254451, 298),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 243604, 266),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237576, 274),
      ))
    }

@delegate:ResourceContentHash(-1_962_706_877)
internal val Res.string.rule_tipi_verbi_card_6: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_6", "rule_tipi_verbi_card_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 256243, 186),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253007, 178),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 254750, 186),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 243871, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 237851, 162),
      ))
    }

@delegate:ResourceContentHash(1_765_534_052)
internal val Res.string.rule_tipi_verbi_card_7: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_7", "rule_tipi_verbi_card_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 256430, 222),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253186, 198),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 254937, 230),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244054, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238014, 194),
      ))
    }

@delegate:ResourceContentHash(-1_407_469_574)
internal val Res.string.rule_tipi_verbi_card_8: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_8", "rule_tipi_verbi_card_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 256653, 206),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253385, 194),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255168, 182),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244253, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238209, 190),
      ))
    }

@delegate:ResourceContentHash(1_879_880_272)
internal val Res.string.rule_tipi_verbi_card_9: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_card_9", "rule_tipi_verbi_card_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 256860, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253580, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255351, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244448, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238400, 102),
      ))
    }

@delegate:ResourceContentHash(864_609_058)
internal val Res.string.rule_tipi_verbi_ex_2gem: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_2gem", "rule_tipi_verbi_ex_2gem", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 256983, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253687, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255470, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244571, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238503, 51),
      ))
    }

@delegate:ResourceContentHash(760_139_014)
internal val Res.string.rule_tipi_verbi_ex_2lit: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_2lit", "rule_tipi_verbi_ex_2lit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257089, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253785, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255580, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244673, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238605, 51),
      ))
    }

@delegate:ResourceContentHash(-1_045_958_212)
internal val Res.string.rule_tipi_verbi_ex_2lit_2: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_2lit_2", "rule_tipi_verbi_ex_2lit_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257039, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253739, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255526, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244623, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238555, 49),
      ))
    }

@delegate:ResourceContentHash(1_561_614_295)
internal val Res.string.rule_tipi_verbi_ex_3gem: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_3gem", "rule_tipi_verbi_ex_3gem", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257141, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253837, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255636, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244721, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238657, 71),
      ))
    }

@delegate:ResourceContentHash(-1_008_381_297)
internal val Res.string.rule_tipi_verbi_ex_3inf: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_3inf", "rule_tipi_verbi_ex_3inf", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257209, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253909, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255720, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244789, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238729, 55),
      ))
    }

@delegate:ResourceContentHash(-993_084_272)
internal val Res.string.rule_tipi_verbi_ex_3lit: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_3lit", "rule_tipi_verbi_ex_3lit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257265, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 253957, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255776, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244841, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238785, 55),
      ))
    }

@delegate:ResourceContentHash(-1_638_017_640)
internal val Res.string.rule_tipi_verbi_ex_4aeinf: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_4aeinf", "rule_tipi_verbi_ex_4aeinf", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257317, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254013, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255836, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244897, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238841, 61),
      ))
    }

@delegate:ResourceContentHash(-1_879_837_555)
internal val Res.string.rule_tipi_verbi_ex_4lit: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_4lit", "rule_tipi_verbi_ex_4lit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257503, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254187, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 256038, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245079, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239027, 67),
      ))
    }

@delegate:ResourceContentHash(2_051_965_910)
internal val Res.string.rule_tipi_verbi_ex_4lit_2: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_4lit_2", "rule_tipi_verbi_ex_4lit_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257383, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254071, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255902, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 244959, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238903, 61),
      ))
    }

@delegate:ResourceContentHash(943_532_607)
internal val Res.string.rule_tipi_verbi_ex_4lit_3: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_4lit_3", "rule_tipi_verbi_ex_4lit_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257445, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254129, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 255968, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245017, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238965, 61),
      ))
    }

@delegate:ResourceContentHash(-2_084_043_534)
internal val Res.string.rule_tipi_verbi_ex_5lit: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_5lit", "rule_tipi_verbi_ex_5lit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257625, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254313, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 256180, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245213, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239157, 55),
      ))
    }

@delegate:ResourceContentHash(-112_059_852)
internal val Res.string.rule_tipi_verbi_ex_5lit_2: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_ex_5lit_2", "rule_tipi_verbi_ex_5lit_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257563, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254255, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 256114, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245155, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239095, 61),
      ))
    }

@delegate:ResourceContentHash(-1_248_808_860)
internal val Res.string.rule_tipi_verbi_title: StringResource by lazy {
      StringResource("string:rule_tipi_verbi_title", "rule_tipi_verbi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257681, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254365, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 256240, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245269, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239213, 49),
      ))
    }

@delegate:ResourceContentHash(486_487_793)
internal val Res.string.rule_vso_card_1: StringResource by lazy {
      StringResource("string:rule_vso_card_1", "rule_vso_card_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257723, 247),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254415, 263),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 256290, 255),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245319, 267),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239263, 251),
      ))
    }

@delegate:ResourceContentHash(1_231_547_294)
internal val Res.string.rule_vso_card_2: StringResource by lazy {
      StringResource("string:rule_vso_card_2", "rule_vso_card_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 257971, 227),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254679, 243),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 256546, 215),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245587, 247),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239515, 219),
      ))
    }

@delegate:ResourceContentHash(-1_821_451_451)
internal val Res.string.rule_vso_card_3: StringResource by lazy {
      StringResource("string:rule_vso_card_3", "rule_vso_card_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 258199, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 254923, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 256762, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245835, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239735, 131),
      ))
    }

@delegate:ResourceContentHash(-634_736_987)
internal val Res.string.rule_vso_card_4: StringResource by lazy {
      StringResource("string:rule_vso_card_4", "rule_vso_card_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 258323, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255063, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 256890, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245975, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239867, 131),
      ))
    }

@delegate:ResourceContentHash(-2_136_111_628)
internal val Res.string.rule_vso_card_5: StringResource by lazy {
      StringResource("string:rule_vso_card_5", "rule_vso_card_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 258479, 143),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255219, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257022, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246119, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239999, 139),
      ))
    }

@delegate:ResourceContentHash(-123_491_105)
internal val Res.string.rule_vso_card_6: StringResource by lazy {
      StringResource("string:rule_vso_card_6", "rule_vso_card_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 258623, 227),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255347, 191),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257166, 195),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246239, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240139, 179),
      ))
    }

@delegate:ResourceContentHash(-357_843_676)
internal val Res.string.rule_vso_ex_ambiguous: StringResource by lazy {
      StringResource("string:rule_vso_ex_ambiguous", "rule_vso_ex_ambiguous", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 258851, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255539, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257362, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246411, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240319, 149),
      ))
    }

@delegate:ResourceContentHash(-21_538_135)
internal val Res.string.rule_vso_ex_object: StringResource by lazy {
      StringResource("string:rule_vso_ex_object", "rule_vso_ex_object", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259009, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255689, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257520, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246565, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240469, 102),
      ))
    }

@delegate:ResourceContentHash(-904_593_140)
internal val Res.string.rule_vso_ex_pronoun: StringResource by lazy {
      StringResource("string:rule_vso_ex_pronoun", "rule_vso_ex_pronoun", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259124, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255792, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257635, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246672, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240572, 55),
      ))
    }

@delegate:ResourceContentHash(-94_200_477)
internal val Res.string.rule_vso_ex_subject: StringResource by lazy {
      StringResource("string:rule_vso_ex_subject", "rule_vso_ex_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259180, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255848, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257695, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246728, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240628, 67),
      ))
    }

@delegate:ResourceContentHash(-2_089_874_553)
internal val Res.string.rule_vso_ex_two_objects: StringResource by lazy {
      StringResource("string:rule_vso_ex_two_objects", "rule_vso_ex_two_objects", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259252, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 255916, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257767, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246792, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240696, 103),
      ))
    }

@delegate:ResourceContentHash(486_433_812)
internal val Res.string.rule_vso_ex_two_subjects: StringResource by lazy {
      StringResource("string:rule_vso_ex_two_subjects", "rule_vso_ex_two_subjects", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259360, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256016, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257887, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246892, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240800, 96),
      ))
    }

@delegate:ResourceContentHash(-1_216_594_053)
internal val Res.string.rule_vso_title: StringResource by lazy {
      StringResource("string:rule_vso_title", "rule_vso_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259469, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256113, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 257992, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 246989, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240897, 46),
      ))
    }

@delegate:ResourceContentHash(-1_148_293_756)
internal val Res.string.scroll_down_desc: StringResource by lazy {
      StringResource("string:scroll_down_desc", "scroll_down_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259520, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256152, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258043, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247028, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240944, 40),
      ))
    }

@delegate:ResourceContentHash(-1_148_293_756)
internal val Res.string.scroll_down_label: StringResource by lazy {
      StringResource("string:scroll_down_label", "scroll_down_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259573, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256205, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258096, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247081, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 240985, 41),
      ))
    }

@delegate:ResourceContentHash(-265_203_176)
internal val Res.string.scroll_to_current_lesson_desc: StringResource by lazy {
      StringResource("string:scroll_to_current_lesson_desc", "scroll_to_current_lesson_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259627, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256259, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258150, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247135, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241027, 69),
      ))
    }

@delegate:ResourceContentHash(-235_577_885)
internal val Res.string.search_compendium_placeholder: StringResource by lazy {
      StringResource("string:search_compendium_placeholder", "search_compendium_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259693, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256329, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258224, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247205, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241097, 49),
      ))
    }

@delegate:ResourceContentHash(-1_362_879_380)
internal val Res.string.search_icon_desc: StringResource by lazy {
      StringResource("string:search_icon_desc", "search_icon_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259743, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256379, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258282, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247255, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241147, 40),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString24Resources(map: MutableMap<String, StringResource>) {
  map.put("rule_infinito_card_2", Res.string.rule_infinito_card_2)
  map.put("rule_infinito_card_3", Res.string.rule_infinito_card_3)
  map.put("rule_infinito_card_4", Res.string.rule_infinito_card_4)
  map.put("rule_infinito_card_5", Res.string.rule_infinito_card_5)
  map.put("rule_infinito_card_6", Res.string.rule_infinito_card_6)
  map.put("rule_infinito_card_7", Res.string.rule_infinito_card_7)
  map.put("rule_infinito_card_8", Res.string.rule_infinito_card_8)
  map.put("rule_infinito_card_9", Res.string.rule_infinito_card_9)
  map.put("rule_infinito_ex_2gem", Res.string.rule_infinito_ex_2gem)
  map.put("rule_infinito_ex_3inf", Res.string.rule_infinito_ex_3inf)
  map.put("rule_infinito_title", Res.string.rule_infinito_title)
  map.put("rule_participi_card_1", Res.string.rule_participi_card_1)
  map.put("rule_participi_card_2", Res.string.rule_participi_card_2)
  map.put("rule_participi_card_3", Res.string.rule_participi_card_3)
  map.put("rule_participi_card_4", Res.string.rule_participi_card_4)
  map.put("rule_participi_ex_htp", Res.string.rule_participi_ex_htp)
  map.put("rule_participi_ex_nfrhtp", Res.string.rule_participi_ex_nfrhtp)
  map.put("rule_participi_title", Res.string.rule_participi_title)
  map.put("rule_possessivo_suffisso_card_1", Res.string.rule_possessivo_suffisso_card_1)
  map.put("rule_possessivo_suffisso_card_2", Res.string.rule_possessivo_suffisso_card_2)
  map.put("rule_possessivo_suffisso_card_3", Res.string.rule_possessivo_suffisso_card_3)
  map.put("rule_possessivo_suffisso_ex_haty", Res.string.rule_possessivo_suffisso_ex_haty)
  map.put("rule_possessivo_suffisso_ex_ib_f", Res.string.rule_possessivo_suffisso_ex_ib_f)
  map.put("rule_possessivo_suffisso_ex_pr_f", Res.string.rule_possessivo_suffisso_ex_pr_f)
  map.put("rule_possessivo_suffisso_ex_pr_i", Res.string.rule_possessivo_suffisso_ex_pr_i)
  map.put("rule_possessivo_suffisso_ex_pr_k", Res.string.rule_possessivo_suffisso_ex_pr_k)
  map.put("rule_possessivo_suffisso_ex_pr_n", Res.string.rule_possessivo_suffisso_ex_pr_n)
  map.put("rule_possessivo_suffisso_ex_pr_ss", Res.string.rule_possessivo_suffisso_ex_pr_ss)
  map.put("rule_possessivo_suffisso_title", Res.string.rule_possessivo_suffisso_title)
  map.put("rule_preposizioni_card_1", Res.string.rule_preposizioni_card_1)
  map.put("rule_preposizioni_card_2", Res.string.rule_preposizioni_card_2)
  map.put("rule_preposizioni_card_3", Res.string.rule_preposizioni_card_3)
  map.put("rule_preposizioni_card_4", Res.string.rule_preposizioni_card_4)
  map.put("rule_preposizioni_card_5", Res.string.rule_preposizioni_card_5)
  map.put("rule_preposizioni_ex_dr_rk_hrw", Res.string.rule_preposizioni_ex_dr_rk_hrw)
  map.put("rule_preposizioni_ex_frase_misteriosa", Res.string.rule_preposizioni_ex_frase_misteriosa)
  map.put("rule_preposizioni_ex_hr_distributivo", Res.string.rule_preposizioni_ex_hr_distributivo)
  map.put("rule_preposizioni_ex_hr_sopra", Res.string.rule_preposizioni_ex_hr_sopra)
  map.put("rule_preposizioni_ex_m_avverbiale", Res.string.rule_preposizioni_ex_m_avverbiale)
  map.put("rule_preposizioni_title", Res.string.rule_preposizioni_title)
  map.put("rule_pronomi_suffissi_card_1", Res.string.rule_pronomi_suffissi_card_1)
  map.put("rule_pronomi_suffissi_card_2", Res.string.rule_pronomi_suffissi_card_2)
  map.put("rule_pronomi_suffissi_ex_egli", Res.string.rule_pronomi_suffissi_ex_egli)
  map.put("rule_pronomi_suffissi_ex_ella", Res.string.rule_pronomi_suffissi_ex_ella)
  map.put("rule_pronomi_suffissi_ex_essi", Res.string.rule_pronomi_suffissi_ex_essi)
  map.put("rule_pronomi_suffissi_ex_esso", Res.string.rule_pronomi_suffissi_ex_esso)
  map.put("rule_pronomi_suffissi_ex_io", Res.string.rule_pronomi_suffissi_ex_io)
  map.put("rule_pronomi_suffissi_ex_noi", Res.string.rule_pronomi_suffissi_ex_noi)
  map.put("rule_pronomi_suffissi_ex_tu_f", Res.string.rule_pronomi_suffissi_ex_tu_f)
  map.put("rule_pronomi_suffissi_ex_tu_m", Res.string.rule_pronomi_suffissi_ex_tu_m)
  map.put("rule_pronomi_suffissi_ex_voi", Res.string.rule_pronomi_suffissi_ex_voi)
  map.put("rule_pronomi_suffissi_title", Res.string.rule_pronomi_suffissi_title)
  map.put("rule_simboli_card_1", Res.string.rule_simboli_card_1)
  map.put("rule_simboli_card_2", Res.string.rule_simboli_card_2)
  map.put("rule_simboli_card_3", Res.string.rule_simboli_card_3)
  map.put("rule_simboli_card_4", Res.string.rule_simboli_card_4)
  map.put("rule_simboli_ex_determinativo", Res.string.rule_simboli_ex_determinativo)
  map.put("rule_simboli_ex_fonogramma", Res.string.rule_simboli_ex_fonogramma)
  map.put("rule_simboli_ex_ideogramma", Res.string.rule_simboli_ex_ideogramma)
  map.put("rule_simboli_title", Res.string.rule_simboli_title)
  map.put("rule_tipi_verbi_card_1", Res.string.rule_tipi_verbi_card_1)
  map.put("rule_tipi_verbi_card_2", Res.string.rule_tipi_verbi_card_2)
  map.put("rule_tipi_verbi_card_3", Res.string.rule_tipi_verbi_card_3)
  map.put("rule_tipi_verbi_card_4", Res.string.rule_tipi_verbi_card_4)
  map.put("rule_tipi_verbi_card_5", Res.string.rule_tipi_verbi_card_5)
  map.put("rule_tipi_verbi_card_6", Res.string.rule_tipi_verbi_card_6)
  map.put("rule_tipi_verbi_card_7", Res.string.rule_tipi_verbi_card_7)
  map.put("rule_tipi_verbi_card_8", Res.string.rule_tipi_verbi_card_8)
  map.put("rule_tipi_verbi_card_9", Res.string.rule_tipi_verbi_card_9)
  map.put("rule_tipi_verbi_ex_2gem", Res.string.rule_tipi_verbi_ex_2gem)
  map.put("rule_tipi_verbi_ex_2lit", Res.string.rule_tipi_verbi_ex_2lit)
  map.put("rule_tipi_verbi_ex_2lit_2", Res.string.rule_tipi_verbi_ex_2lit_2)
  map.put("rule_tipi_verbi_ex_3gem", Res.string.rule_tipi_verbi_ex_3gem)
  map.put("rule_tipi_verbi_ex_3inf", Res.string.rule_tipi_verbi_ex_3inf)
  map.put("rule_tipi_verbi_ex_3lit", Res.string.rule_tipi_verbi_ex_3lit)
  map.put("rule_tipi_verbi_ex_4aeinf", Res.string.rule_tipi_verbi_ex_4aeinf)
  map.put("rule_tipi_verbi_ex_4lit", Res.string.rule_tipi_verbi_ex_4lit)
  map.put("rule_tipi_verbi_ex_4lit_2", Res.string.rule_tipi_verbi_ex_4lit_2)
  map.put("rule_tipi_verbi_ex_4lit_3", Res.string.rule_tipi_verbi_ex_4lit_3)
  map.put("rule_tipi_verbi_ex_5lit", Res.string.rule_tipi_verbi_ex_5lit)
  map.put("rule_tipi_verbi_ex_5lit_2", Res.string.rule_tipi_verbi_ex_5lit_2)
  map.put("rule_tipi_verbi_title", Res.string.rule_tipi_verbi_title)
  map.put("rule_vso_card_1", Res.string.rule_vso_card_1)
  map.put("rule_vso_card_2", Res.string.rule_vso_card_2)
  map.put("rule_vso_card_3", Res.string.rule_vso_card_3)
  map.put("rule_vso_card_4", Res.string.rule_vso_card_4)
  map.put("rule_vso_card_5", Res.string.rule_vso_card_5)
  map.put("rule_vso_card_6", Res.string.rule_vso_card_6)
  map.put("rule_vso_ex_ambiguous", Res.string.rule_vso_ex_ambiguous)
  map.put("rule_vso_ex_object", Res.string.rule_vso_ex_object)
  map.put("rule_vso_ex_pronoun", Res.string.rule_vso_ex_pronoun)
  map.put("rule_vso_ex_subject", Res.string.rule_vso_ex_subject)
  map.put("rule_vso_ex_two_objects", Res.string.rule_vso_ex_two_objects)
  map.put("rule_vso_ex_two_subjects", Res.string.rule_vso_ex_two_subjects)
  map.put("rule_vso_title", Res.string.rule_vso_title)
  map.put("scroll_down_desc", Res.string.scroll_down_desc)
  map.put("scroll_down_label", Res.string.scroll_down_label)
  map.put("scroll_to_current_lesson_desc", Res.string.scroll_to_current_lesson_desc)
  map.put("search_compendium_placeholder", Res.string.search_compendium_placeholder)
  map.put("search_icon_desc", Res.string.search_icon_desc)
}
